<div *ngIf="showLoadingIndicator"  class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>

<form *ngIf="!showLoadingIndicator" [formGroup]="examinationForm">
  <div class="row">

      <div class="col-lg-12">
        <div class="card card-primary">
          <div class="card-header text-uppercase"> {{title}} </div>
          <div class="card-body">


  <!-- <label>Notes: </label>
  <input formControlName="Caption" /><br> -->


<div formArrayName="ApplicantExaminations">
  <div *ngFor="let appExam of getApplicantExaminationArray(examinationForm); let i=index">
    <div formGroupName="{{i}}">
    <div class="tile">
        <div class="tile-title-w-btn text-primary">
          <h6 class="title text-uppercase">{{i+1}}. Examination History</h6>
          <div class="btn-group">
            <!-- <button *ngIf="last" class="btn btn-primary" (click)="onAddExaminationClick()"><i class="fa fa-lg fa-plus"></i>Add
              New</button> -->
            <button class="btn btn-primary" [disabled]="!appExam.valid" (click)="onSaveExaminationClick(appExam,i)"><i class="fa fa-lg fa-save"></i>Save Exam Record</button>
            <button class="btn btn-danger"  (click)="onRemoveExaminationClick(i)"><i
                class="fa fa-lg fa-trash"></i>Remove</button>
          </div>
        </div>
        <div class="tile-body">
          <hr />

          <!-- Local Student -->
          <div *ngIf="!isForignStudent()">

          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label> Name Of School <small class="text-muted">(required)</small> </label>


                <select  formControlName="InstitutionId" class="form-control">
                  <option value="">SELECT INSTITUTION (Eg. PRIVATE CANDIDATE )</option>
                  <option *ngFor="let is of institutions" value="{{is.ValueId}}">
                    {{is.DisplayValue}}
                  </option>

                </select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group" *ngIf="!applicantData.IsForignStudent">
                <label>
                  School Code <small class="text-muted">(required)</small>
                </label>
                <input type="text" formControlName="SchoolCode"  class="form-control">
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label> Examination Centre <small class="text-muted">(required)</small> </label>
                <input type="text" formControlName="ExaminationCentre"  class="form-control">

              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>
                  Region <small class="text-muted">(required)</small>
                </label>
                <select formControlName="RegionId" class="form-control">
                  <option value="">SELECT REGION</option>
                  <option *ngFor="let rs of regions" value="{{rs.ValueId}}">
                    {{rs.DisplayValue}}
                  </option>

                </select>
              </div>
            </div>
          </div>




          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label> Application Type <small class="text-muted">(required)</small> </label>
                <select formControlName="ApplicationModeId" class="form-control">
                  <option value="">SELECT APPLICATION MODE</option>
                  <option *ngFor="let ams of applicationModes" value="{{ams.ValueId}}">
                    {{ams.DisplayValue}}
                  </option>

                </select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>
                  Exam Index No <small class="text-muted">(required)</small>
                </label>
                <input type="text" formControlName="ExamIndexNumber"  class="form-control">

              </div>
            </div>
          </div>




          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label> Year of Exam Sitting <small class="text-muted">(required)</small> </label>
                <select formControlName="YearOfExamSitting" class="form-control">
                  <option value="">SELECT YEAR</option>
                  <option *ngFor="let yes of yearOfExamSittings" value="{{yes.Name}}">
                    {{yes.Name}}
                  </option>

                </select>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>
                  Period of Exam Sitting <small class="text-muted">(required)</small>
                </label>
                <select formControlName="ExamPeriodId" class="form-control">
                  <option value="">SELECT PERIOD</option>
                  <option *ngFor="let yes of examPeriods" value="{{yes.ValueId}}">
                    {{yes.DisplayValue}}
                  </option>

                </select>
              </div>
            </div>
          </div>

        </div>



          <!-- Forign Student -->
          <div  *ngIf="isForignStudent()">

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label> Name Of School <small class="text-muted">(required)</small> </label>
                    <input type="text"
                    formControlName="InstitutionName" placeholder=""   class="form-control">

                  </div>
                </div>

                <div class="col-md-6">
                    <div class="form-group">
                        <label> Year of Exam Sitting <small class="text-muted">(required)</small> </label>
                        <select formControlName="YearOfExamSitting" class="form-control">
                          <option value="">SELECT YEAR</option>
                          <option *ngFor="let yes of yearOfExamSittings" value="{{yes.Name}}">
                            {{yes.Name}}
                          </option>

                        </select>
                      </div>

                </div>

              </div>
          </div>

          <hr />

          <h6 class="form-header text-center text-uppercase text-danger">
              PLEASE SELECT Examination Type
            </h6>
            <select (change)="onSelectApplicantExaminationTypeId(appExam,i)" formControlName="ApplicantExaminationTypeId"
              class="form-control">
              <option value="">Select exam type</option>
              <option *ngFor="let et of examinationTypes" value="{{et.ValueId}}">
                {{et.DisplayValue}}
              </option>

            </select>





            <div formArrayName="ApplicantExaminationItems" class="app-exam-item">
                <div [formGroupName]="j" *ngFor="let examItem of getApplicantExaminationItems(appExam); let j = index">





                  <div class="table grade-data">
                    <div class="table-head" >
                      <p class="heading-primary">Grades Attained</p>
                      <p class="heading-secondary" *ngIf="isHideSubTitleShow(appExam)">
                        <span class="elective">{{leftCourseName}}</span>
                        <span class="core">{{rightCourseName}}</span>
                      </p>
                    </div>
                    <div class="table-left">
                      <div class="electives">

                        <div formArrayName="ElectiveSubjects">
                          <div [formGroupName]="eleIndex" *ngFor="let valItem of getApplicantElectiveCourses(examItem); let eleIndex = index">


                            <div class="course-grad">
                              <label for="grade" class="course" *ngIf="valItem.value.Name!='#'">{{valItem.value.Name}}</label>
                              <input formControlName="Name" class="course-input form-control" type="text" *ngIf="valItem.value.Name=='#'">
                              <select formControlName="ApplicantCourseGradeTypeItemId" id="grade" class="form-control">
                                <option value="">SELECT {{valItem.value.Grades[0].ApplicantCourseGradeType}} GRADE</option>
                                <option *ngFor="let grade of valItem.value.Grades" class="grade-value" value="{{grade.ApplicantCourseGradeTypeItemId}}">{{grade.ApplicantCourseGradeTypeItem}}
                                </option>
                              </select>
                            </div>

                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="table-right">
                      <div class="core">
                        <div formArrayName="CoreSubjects">
                          <div [formGroupName]="coreIndex" *ngFor="let valItem of getApplicantCoreCourses(examItem); let coreIndex = index">

                            <div class="course-grad">
                              <label for="grade" class="course" *ngIf="valItem.value.Name!='#'">{{valItem.value.Name}}</label>
                              <input formControlName="Name" class="course-input form-control" type="text" *ngIf="valItem.value.Name=='#'">
                              <select formControlName="ApplicantCourseGradeTypeItemId" id="grade" class="form-control">
                                <option value="">SELECT {{valItem.value.Grades[0].ApplicantCourseGradeType}} GRADE</option>
                                <option *ngFor="let grade of valItem.value.Grades" class="grade-value" value="{{grade.ApplicantCourseGradeTypeItemId}}">{{grade.ApplicantCourseGradeTypeItem}}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>


                      <!-- <div class="optional">
                        <p class="heading-secondary" *ngIf="isHideSubTitleShow(appExam)">
                          <span class="optional">Optional Subjects</span>
                        </p>
                        <div formArrayName="OptionalSubjects">
                          <div [formGroupName]="optIndex" *ngFor="let valItem of getApplicantOptionalCourses(examItem); let optIndex = index">

                            <div class="course-grad">
                              <input formControlName="Name" class="course-input form-control" type="text"
                                     >
                              <select formControlName="ApplicantCourseGradeTypeItemId" id="grade" class="form-control grade">
                                <option value="">SELECT {{valItem.value.Grades[0].ApplicantCourseGradeType}} GRADE</option>
                                <option *ngFor="let grade of valItem.value.Grades" class="grade-value" value="{{grade.ApplicantCourseGradeTypeItemId}}">{{grade.ApplicantCourseGradeTypeItem}}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div> -->

                    </div>

                    <div *ngIf="examItem.value.CoreSubjects==0" >
                        <br/>

                      <p >Please scan your examination information (English Version) and email it to admissions@umat.edu.gh</p>
                      <br/>
                      <p >NB: All Examination Certificates should be translated into English  before emailing to the admissions@umat.edu.gh</p>
                    </div>
                  </div>


                </div>
              </div>


              <hr/>
              <br/>
              <div class="tile-title-w-btn text-primary">

                <h6 class="title text-uppercase text-danger">Note: You must click on save anytime you update your examination data before you click continue</h6>
                <div class="btn-group">
                  <!-- <button *ngIf="last" class="btn btn-primary" (click)="onAddExaminationClick()"><i class="fa fa-lg fa-plus"></i>Add
                    New</button> -->
                  <button class="btn btn-primary" [disabled]="!appExam.valid" (click)="onSaveExaminationClick(appExam,i)"><i class="fa fa-lg fa-save"></i>Save Exam Record</button>
                  <button class="btn btn-danger"  (click)="onRemoveExaminationClick(i)"><i
                      class="fa fa-lg fa-trash"></i>Remove</button>
                </div>
              </div>





        </div>


      </div>

    </div>
  </div>
  <!-- <pre>{{ examinationForm.value | json }}</pre> -->

  <div class="form-group">
      <button *ngIf="!isCertificateStudent()" type="button" (click)="onAddExaminationClick()"
      class="btn btn-primary btn-block waves-effect waves-light m-1">
        <i class="icon-magnifier-add"></i> {{getAddExamButtonName()}}
      </button>


        <div *ngIf="isCertificateStudent()">
        <!-- <h5 class="mr-3 text-danger"> NOTE:</h5> -->
              <div class="media-body">
                <h5 class="mt-0 mb-1"><mark>All Certificate Applicants should click continue and attach relevant
                    documents during submission of printed forms</mark> </h5>
              </div>

        </div>
  </div>


</div>




</div>


<div class="form-footer">
  <div class="form-group text-center">
    <button class="btn btn-default waves-effect waves-light m-1" (click)="goToPrevious(examinationForm)"><i
        class="fa fa-backward"></i> Go Back</button>

    <button class="btn btn-primary waves-effect waves-light m-1" id="next" [disabled]="!isFormValid()"
      (click)="goToNext(examinationForm)">Continue</button>
  </div>
</div>
</div>
</div>

</div>

</form>

